import React, { useEffect, useState } from "react";
import { Row, Col, Container } from "reactstrap";
import GridsCSS from "./Grid/GridsCSS";
import CheckMark from "../images/checkmark.png";
 
const CSSImages = (props) => {
  let model = props.model;
  let machine_card_details = props.machine_card_details;
  let imageUrls = props.imageUrls;

  return (
    <Container>
      {model === "W601" ? (
        <>
          <Row className="align-items-center text-center ">
            <Col xs={12} sm={12} md={12} lg={12} xl={1} xxl={1}></Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
              {renderPart("Pillar_Upper_LH", imageUrls.Pillar_Upper_LH)}
              <h5 className="parts-name-text  mt-4">
                D - Pillar Upper OTR - LH
              </h5>
            </Col>
            
            <Col xs={12} sm={12} md={12} lg={12} xl={4} xxl={4}  className="mx-5">
              {renderPart("Roof", imageUrls.Roof, model)}
              <h5 className="parts-name-text mt-4">Roof Top</h5>
            </Col>
             
            <Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
              {renderPart("Pillar_Upper_RH", imageUrls.Pillar_Upper_RH)}
              <h5 className="parts-name-text mt-4">
                D - Pillar Upper OTR - RH
              </h5>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={1} xxl={1}></Col>
          </Row>

          <Row className="mt-3 align-items-center text-center">
          <Col xs={12} sm={12} md={12} lg={12} xl={1} xxl={1}></Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3} >

              {renderPart("Pillar_Lower_LH", imageUrls.Pillar_Lower_LH)}
              <h5 className="parts-name-text   mt-4">
                D - Pillar Lower OTR - LH
              </h5>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={4} xxl={4} >
              {renderPart(
                "Rear_Header_Outer_Panel_Top_Side",
                imageUrls.Rear_Header_Outer_Panel_Top_Side
              )}
              <h5 className="parts-name-text mt-3 ">
                Rear Header Outer Panel - Top Side
              </h5>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={1} xxl={1}></Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
              {renderPart("Pillar_Lower_RH", imageUrls.Pillar_Lower_RH)}
              <h5 className="parts-name-text mt-4">
                D - Pillar Lower OTR - RH
              </h5>
            </Col>
           
          </Row>
        </>
      ) : (
        <>
          <Row className="text-center mx-4">
            <Col lg={1} xl={1} xxl={1}></Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
              {renderPart("Top_Tail_Lamp_LH", imageUrls.Top_Tail_Lamp_LH)}
              <h5 className="parts-name-text mt-4">
                Panel Assy Tail Lamp LH Top
              </h5>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={4} xxl={4}>
              {renderPart("Roof", imageUrls.Roof, model)}
              <h5 className="parts-name-text mt-4">Roof Top</h5>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={3} xxl={3}>
              {renderPart("Top_Tail_Lamp_RH", imageUrls.Top_Tail_Lamp_RH)}
              <h5 className="parts-name-text mt-4">
                Panel Assy Tail Lamp RH Top
              </h5>
            </Col>
            <Col lg={1} xl={1} xxl={1}></Col>
          </Row>

          <Row className="mt-4 text-center ">
            <Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2}></Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={4} xxl={4}>
              {renderPart(
                "Bottom_Tail_Lamps_LH_RH",
                imageUrls.Bottom_Tail_Lamps_LH_RH
              )}
              <h5 className="parts-name-text mt-4">
                Panel Assy Tail Lamp LH RH Bottom
              </h5>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12} xl={1} xxl={1}></Col>
            <Col
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={1}
              xxl={1}
              className="text-center"
            >
              {renderPart("Hinge_Swing_Gate", imageUrls.Hinge_Swing_Gate)}
              <h5 className="parts-name-text mt-4">Hinge Swing Gate</h5>
            </Col>

            <Col xs={12} sm={12} md={12} lg={12} xl={2} xxl={2}></Col>
          </Row>
        </>
      )}
    </Container>
  );

  function renderPart(partName, imageUrl) {
    const partDetails = machine_card_details?.Parts?.[partName];
    const isStatusTrue = partDetails?.status === true;
    let isRoof = partName === "Roof" ? true : false;
    if (partName === "Rear_Header_Outer_Panel_Top_Side") {
      isRoof = true;
    }
    partName = partName === "Roof" && model === "Z101" ? "z101Roof" : partName;
    return (
      <Col
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        className={`mt-5 ${
          isStatusTrue
            ? "text-center image-background"
            : "text-center blur-bg image-background"
        }${isRoof ? "-roof" : ""}`}
        style={{
          backgroundImage: `url(${imageUrl})`,
        }}
      >
        {isStatusTrue ? (
          <>
            <GridsCSS
              highlightedCells={partDetails.grids}
              partName={partName}
            />{" "}
          </>
        ) : (
          <img
            src={CheckMark}
            alt="Checkmark"
            className="check_tickmark"
            style={{ marginTop: "5%" }}
          />
        )}
      </Col>
    );
  }
};

export default CSSImages;
